import { IndexTabTrigger, IndexTabsList, TabsGroup } from 'ui/tabsGroup';
import { InputText } from 'ui/inputs';
import { FilterContainer } from './AnonymousUserTracking.styled';
import { CriteriaTableTab } from '../types';
import { useCriteriaIndexQueryContext } from '../context/CriteriaIndexQueryContext';

export const AnonymousCriteriaFilterHeader = () => {
  const { stateFilterTab, setStateFilterTab, searchTextInput, setSearchText } =
    useCriteriaIndexQueryContext();
  return (
    <FilterContainer>
      <TabsGroup
        value={stateFilterTab}
        onValueChange={(newTab) => setStateFilterTab(newTab as CriteriaTableTab)}
      >
        <IndexTabsList>
          <IndexTabTrigger value={CriteriaTableTab.ALL}>All</IndexTabTrigger>
          <IndexTabTrigger value={CriteriaTableTab.LIVE}>Live</IndexTabTrigger>
          <IndexTabTrigger value={CriteriaTableTab.OFF}>Off</IndexTabTrigger>
          <IndexTabTrigger value={CriteriaTableTab.ARCHIVED}>Archived</IndexTabTrigger>
        </IndexTabsList>
      </TabsGroup>
      <InputText
        value={searchTextInput}
        onChange={setSearchText}
        placeholder="Search..."
        width="360px"
      />
    </FilterContainer>
  );
};
